import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import Routes from '@/routes';
import VueTheMask from 'vue-the-mask';
import VueSocketIO from 'vue-socket.io';
 
Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueTheMask);

// require("./plugins/firebase");

const router = new VueRouter({
  mode: 'history',
  routes: Routes
});

router.beforeEach((to, from, next) => {

  const token = localStorage.getItem('@bsi:token');

  if(to.name === "Signin") {
    localStorage.removeItem('@bsi:token');
    localStorage.removeItem('@bsi:user');
    return next();
  }

  if(token) {
    
    Vue.use(new VueSocketIO({
      connection: process.env.VUE_APP_API_URL,
      options: {  
          extraHeaders: { Authorization: `Bearer ${token}` }, 
          query: `token=${token}`
        }
      }

    ))

  }
  
  next();
  
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')